import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { store } from './store';

import AppLayout from './pages/_layout/app-layout';
import { AdminDashboardPage } from './features/admin-dashboard/admin-dashboard-page';
import { CustomerListPage } from './features/admin-dashboard/customers/customer-list-page';
import { AdminLogsPage } from './pages/admin-logs-page';
import { DeviceStatusPage } from './pages/device-status-page';
import HomePage from './pages/home-page';
import SigninPage from './pages/signin-page';

export function App() {
  return (
    <Provider store={store}>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/" element={<AppLayout />}>
            <Route path="/admin/logs" element={<AdminLogsPage />} />
            <Route path="/admin/device-status" element={<DeviceStatusPage />} />
            <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
            <Route path="/admin/customers" element={<CustomerListPage />} />
            <Route path="/signin" element={<SigninPage />} />
            <Route path="/" element={<HomePage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </Provider>
  );
}
